export default "__VITE_ASSET__wvjmEHWV__"